import * as React from 'react';

export interface ISeatInfoErrorMessageProps {
    isError: boolean;
    errorKey: string;
    showNotice: boolean;
    message: string;
}

export const SeatInfoNoticeMessage: React.SFC<ISeatInfoErrorMessageProps> = (props) => {
    let error = null;
    const useTagAlert = '<use xlink:href="#icon-alert" />';

    if (props.showNotice) {
        if (isHtmlPrompt(props.message)) {
            return <div data-error={props.errorKey} className={"seat-info-options seat-info-options-notice" + (props.isError ? " error-notice" : "")}>

                <div className="rich-text caption-paragraph" dangerouslySetInnerHTML={{ __html: props.message }}></div>
            </div>;
        } else {
            return <div data-error={props.errorKey} className={"seat-info-options" + (props.isError ? " error-notice" : "")}>
                {props.isError ?
                    <svg dangerouslySetInnerHTML={{ __html: useTagAlert }} />

                    : null
                }

                <span className={"seat-info-options-notice caption-paragraph" + (props.isError ? " error-notice" : "")}>{props.message}</span>
            </div>;
        }
    } else {
        return null;
    }
}

function isHtmlPrompt(message: string) {
    if (message === null)
        return false;
    return message.substr(0, 4) === "<div";
}